import styled from 'styled-components'

import { ProgressiveAssetStyles, TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  padding: ${o => o.theme.spacing(1.5, 5)};
`

const imageSize = '100px'

export const Top = styled.div`
  display: flex;

  ${ProgressiveAssetStyles.Container} {
    height: ${imageSize};
    width: ${imageSize};
  }

  ${ProgressiveAssetStyles.Image} {
    background: ${o => o.theme.color.fill.subtle};
  }
`

export const ImagePlaceholder = styled.div`
  background: ${o => o.theme.color.fill.subtle};
  height: ${imageSize};
  width: ${imageSize};
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100px;
  justify-content: space-between;
  margin-inline-start: ${o => o.theme.spacing(3)};
`

export const Title = styled(TypeStyle.HeadlineExtraExtraSmall)``

export const OptionsText = styled(TypeStyle.BodySmall)`
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
`

export const FitDescription = styled.span`
  text-transform: capitalize;
`
